/* Costack live links - 15 Sep 2026
 * THE SHOP PAGE SENT MOST CATEGORY TRAFFIC TO DEAD ENDS. Four of the six
 * "Find your spice by use" tiles pointed at sold-out products (Chicken & Turkey,
 * Meat & BBQ, Suya, Jollof) and so did the hero's "Start with our bestseller".
 * Hardcoding a replacement only moves the problem to the next stockout, so every
 * one of these links is checked against live stock and repointed to the next
 * buyable blend in the same category. The intended product comes back on its own
 * the moment it is restocked, because the original href is kept and restored.
 * Falls back to the full collection if a whole category is out.
 * Rice & Grain falls to Complete Seasoning rather than Vegetable so it does not
 * land on the same product as Veggies & Sides; Complete is the blend the copy
 * already sells for rice dishes.
 */
(function () {
  'use strict';

  var CHAINS = {
    'costack-chicken-and-turkey-seasoning': ['costack-all-purpose-seasoning', 'costack-complete-seasoning', 'costack-adobo-seasoning-with-pepper'],
    'costack-fish-seasoning': ['costack-crayfish-seasoning', 'costack-all-purpose-seasoning'],
    'costack-meat-seasoning': ['costack-adobo-seasoning-with-pepper', 'costack-cameroon-pepper', 'costack-all-purpose-seasoning'],
    'costack-suya-spice': ['costack-cameroon-pepper', 'costack-adobo-seasoning-with-pepper'],
    'costack-jollof-rice-seasoning': ['costack-fried-rice-seasoning', 'costack-complete-seasoning', 'costack-all-purpose-seasoning'],
    'costack-fried-rice-seasoning': ['costack-complete-seasoning', 'costack-all-purpose-seasoning'],
    'costack-universal-vegetable-seasoning': ['costack-all-purpose-seasoning', 'costack-complete-seasoning'],
    'costack-pepper-soup-mix-seasoning': ['costack-crayfish-seasoning', 'costack-cameroon-pepper'],
    'costack-lemon-pepper': ['costack-all-purpose-seasoning', 'costack-complete-seasoning'],
    'costack-garlic-powder': ['costack-granulated-onion', 'costack-all-purpose-seasoning'],
    'costack-granulated-onion': ['costack-garlic-powder', 'costack-all-purpose-seasoning']
  };
  var FALLBACK = '/collections/all-spices-and-seasonings';
  var SELECTORS = '.costack-filter-strip__tile, .costack-spices-hero__cta';

  var stock = null;
  var loading = null;
  function loadStock() {
    if (stock) return Promise.resolve(stock);
    if (loading) return loading;
    loading = fetch('/collections/all-spices-and-seasonings/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var m = {};
        (d.products || []).forEach(function (p) {
          m[p.handle] = (p.variants || []).some(function (v) { return v.available; });
        });
        stock = m;
        return m;
      })
      .catch(function () { stock = {}; return stock; });
    return loading;
  }

  function handleOf(href) {
    if (!href || href.indexOf('/products/') === -1) return null;
    return href.split('/products/')[1].split('/')[0].split('?')[0].split('#')[0];
  }

  function repoint() {
    var links = document.querySelectorAll(SELECTORS);
    if (!links.length) return;
    loadStock().then(function (m) {
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        var href = a.getAttribute('href');
        var original = a.getAttribute('data-cstk-original');
        var intended = original || href;
        var h = handleOf(intended);
        if (!h) continue;

        /* Unknown handles are left alone: only products in the shop collection
           are judged, so bundles and pages are never rewritten. */
        if (m[h] === undefined) continue;

        if (m[h]) {
          if (href !== intended) a.setAttribute('href', intended);
          if (original) a.removeAttribute('data-cstk-original');
          continue;
        }

        var chain = CHAINS[h] || [];
        var pick = null;
        for (var j = 0; j < chain.length; j++) { if (m[chain[j]]) { pick = chain[j]; break; } }
        var want = pick ? '/products/' + pick : FALLBACK;
        if (href !== want) {
          if (!original) a.setAttribute('data-cstk-original', intended);
          a.setAttribute('href', want);
        }
      }
    });
  }

  var queued = false;
  function tick() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; repoint(); }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repoint);
  else repoint();
  try { new MutationObserver(tick).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  [600, 2000, 4000].forEach(function (t) { setTimeout(repoint, t); });
})();
